// extracted by mini-css-extract-plugin
export default {"info":"HuexyYfCmWJoBxGmzFPO","title":"jcZwdJxx9JNJeBb8SRii","description":"qrnLenpcVF_T0QIWxqbx","btn":"fmTmhJvdwNH2a7pr4O3p","root":"C76wquuDDGEfzUxNikbw"};